{
  "it": {
    "title": {
      "default": "FleetYards.net",
      "defaultShort": "FleetYards",
      "defaultAdmin": "FleetYards.net Command",
      "defaultAdminShort": "FltYrds Command",
      "defaultDocs": "FleetYards.net Documentation",
      "defaultDocsShort": "FleetYards Docs",
      "home": "Home",
      "ships": {
        "index": "Navi",
        "viewer": "Ship Viewer"
      },
      "ship": "%{name} - %{manufacturer}",
      "shipImages": "%{name} Immagini",
      "shipVideos": "%{name} Video",
      "shipViewer": "%{name} Viewer",
      "images": "Immagini",
      "stats": "Statistiche",
      "login": "Accedi",
      "signUp": "Registrati",
      "embed": "Widget Incorporato",
      "apiV1": "API V1",
      "apiV1Schema": "Schema",
      "apiV1Pagination": "Paginazione",
      "authApiV1": "Auth API V1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "Schema",
      "hangar": {
        "index": "Il Mio Hangar",
        "preview": "Anteprima del Mio Hangar",
        "stats": "Statistiche del Mio Hangar",
        "import": "Importa",
        "public": "Hangar di %{user}",
        "publicStats": "Statistiche dell'Hangar di %{user}",
        "wishlist": "Lista dei desideri",
        "publicWishlist": "Lista dei desideri di %{user}",
        "vehicleLoadouts": "Loadouts della nave",
        "inventories": "My Hangar Inventories",
        "inventory": "%{inventory}",
        "vehicleCargo": "Carico della nave"
      },
      "requestPassword": "Richiedi la password",
      "changePassword": "Cambia la password",
      "fleets": {
        "add": "Crea una nuova Flotta",
        "preview": "Anteprima della Flotta",
        "invites": "Inviti Alla Flotta",
        "members": {
          "index": "%{fleet} Members",
          "invites": "%{fleet} Invites",
          "worldmap": "Mappa mondiale dei membri di %{fleet}",
          "starmap": "Mappa stellare dei membri di %{fleet}"
        },
        "stats": "Statistiche di %{fleet}",
        "logistics": {
          "index": "%{fleet} Logistics",
          "inventories": "%{fleet} Inventories"
        },
        "missions": {
          "index": "Missioni di %{fleet}",
          "create": "Crea Missione - %{fleet}",
          "edit": {
            "basic": "Modifica Missione - %{fleet}",
            "description": "Modifica Descrizione - %{fleet}",
            "teams": "Modifica Team e Slot - %{fleet}"
          },
          "show": "Missione di %{fleet}"
        },
        "events": {
          "index": "Eventi di %{fleet}",
          "calendar": "Calendario di %{fleet}",
          "create": "Crea Evento - %{fleet}",
          "edit": {
            "basic": "Modifica Evento - %{fleet}",
            "description": "Modifica Descrizione - %{fleet}",
            "teams": "Modifica Team e Slot - %{fleet}"
          },
          "show": "Evento di %{fleet}"
        },
        "settings": {
          "index": "Impostazioni di %{fleet}",
          "fleet": "Impostazioni di %{fleet}",
          "membership": "Appartenenza a %{fleet}",
          "roles": "Ruoli di %{fleet}",
          "notifications": "Impostazioni Notifiche di %{fleet}",
          "discord": "Impostazioni Discord di %{fleet}",
          "calendar": "Impostazioni Calendario di %{fleet}",
          "features": "Funzionalità di %{fleet}"
        }
      },
      "roadmap": {
        "index": "Roadmap",
        "ships": "Roadmap Delle Navi",
        "changes": "Modifiche alla Roadmap"
      },
      "settings": {
        "index": "Impostazioni del Profilo",
        "profile": "Impostazioni profilo",
        "account": "Account",
        "hangar": "Impostazioni dell'Hangar",
        "privacy": "Impostazioni Privacy",
        "features": "Flag funzionalità",
        "connections": "Connessioni",
        "oauthApplications": "Applicazioni OAuth",
        "notifications": "Impostazioni Notifiche",
        "calendar": "Abbonamento al calendario",
        "security": "Sicurezza dell'account",
        "twoFactor": {
          "enable": "Attiva Autenticazione A Due Fattori",
          "disable": "Disattiva Autenticazione A Due Fattori",
          "backupCodes": "Genera Codici Di Backup Autenticazione a Due Fattori"
        }
      },
      "compare": {
        "ships": "Confronta Navi"
      },
      "notFound": "404",
      "tools": {
        "index": "Strumenti",
        "travelTimes": "Tempi di Viaggio",
        "cargoGrids": "Griglie di carico"
      },
      "impressum": "Info legali",
      "privacyPolicy": "Informativa sulla privacy",
      "cookiePolicy": "Informativa sui Cookie",
      "visualTests": {
        "index": "Test Visivi",
        "panels": "Pannelli - Test Visivi",
        "buttons": "Pulsanti - Test Visivi",
        "events": "Eventi",
        "typography": "Tipografia - Test visivi",
        "forms": "Moduli - Test visivi",
        "tables": "Tabelle - Test Visivi",
        "lists": "Elenchi - Test visivi",
        "metrics": "Metriche - Test visivi",
        "states": "Stati - Test visivi",
        "notifications": "Notifiche - Test Visivi",
        "syncModal": "Modal sincronizzazione - Test Visivi",
        "overlays": "Overlay - Test Visivi",
        "supportHint": "Suggerimento supporto - Test Visivi",
        "media": "Media - Test Visivi",
        "charts": "Grafici - Test Visivi",
        "chips": "Chips - Test Visivi",
        "notificationCenter": "Centro notifiche - Test Visivi"
      },
      "admin": {
        "models": {
          "index": "Modelli",
          "new": "Nuovo Modello",
          "edit": {
            "index": "Modifica %{manufacturer} %{model}",
            "metrics": "Modifica metriche di %{manufacturer} %{model}",
            "prices": "Modifica prezzi di %{manufacturer} %{model}",
            "fleetchart": "Modifica immagini del grafico flotta di %{manufacturer} %{model}",
            "positions": "Modifica posizioni di %{manufacturer} %{model}",
            "hardpoints": "Modifica hardpoint di %{manufacturer} %{model}",
            "cargoAndFuel": "Modifica carburante di %{manufacturer} %{model}",
            "cargoHolds": "Modifica stive di carico di %{manufacturer} %{model}",
            "docks": "Modifica dock di %{manufacturer} %{model}",
            "modules": "Modifica moduli di %{manufacturer} %{model}",
            "paints": "Modifica verniciature di %{manufacturer} %{model}",
            "images": "Modifica immagini di %{manufacturer} %{model}",
            "videos": "Modifica video di %{manufacturer} %{model}",
            "loaners": "Modifica prestiti di %{manufacturer} %{model}",
            "snubCrafts": "Modifica Snub Craft di %{manufacturer} %{model}",
            "upgrades": "Modifica miglioramenti di %{manufacturer} %{model}",
            "packages": "Modifica pacchetti di %{manufacturer} %{model}",
            "history": "Modifica cronologia di %{manufacturer} %{model}"
          }
        },
        "components": {
          "index": "Componenti",
          "new": "Nuovo Componente",
          "edit": {
            "index": "Modifica componente",
            "prices": "Edit Component Prices",
            "history": "Modifica cronologia del componente"
          }
        },
        "manufacturers": {
          "index": "Produttori",
          "new": "Nuovo Produttore",
          "edit": {
            "index": "Modifica Produttore"
          }
        },
        "supporterContributions": {
          "index": "Contributi dei sostenitori",
          "new": "Nuovo contributo",
          "edit": "Modifica contributo"
        },
        "fundingGoals": {
          "index": "Obiettivi di finanziamento",
          "new": "Nuovo obiettivo di finanziamento",
          "edit": "Modifica obiettivo di finanziamento"
        },
        "users": {
          "index": "Utenti",
          "edit": "Modifica Utente",
          "inventories": "Inventari dell'utente",
          "inventory": "Inventario dell'utente",
          "inventoryItem": "Voce di inventario",
          "fleets": "Flotte dell'utente"
        },
        "vehicles": {
          "index": "Veicoli",
          "edit": "Modifica Veicolo"
        },
        "admins": {
          "index": "Amministratori",
          "new": "Nuovo Admin",
          "edit": "Modifica Admin"
        },
        "fleets": {
          "index": "Flotte",
          "edit": "Modifica Flotta",
          "members": "Membri della flotta",
          "memberEdit": "Modifica membro della flotta",
          "history": "Cronologia della flotta",
          "roles": "Ruoli della flotta",
          "role": "Ruolo della flotta",
          "inventories": "Inventari della flotta",
          "inventory": "Inventario della flotta",
          "inventoryItem": "Voce di inventario"
        },
        "oauthApplications": {
          "index": "Applicazioni OAuth",
          "new": "Nuova applicazione OAuth",
          "edit": "Modifica applicazione OAuth"
        },
        "features": {
          "index": "Flag funzionalità",
          "show": "Dettagli funzionalità"
        },
        "images": {
          "index": "Immagini"
        },
        "notifications": {
          "index": "Notifiche"
        },
        "maintenance": {
          "index": "Manutenzione",
          "pghero": "PgHero",
          "features": "Funzionalità",
          "flipper": "Flipper UI",
          "workers": "Workers",
          "tasks": "Attività",
          "imports": "Importazioni",
          "importDetail": "Dettaglio importazione",
          "rsiApiStatus": "Stato API RSI"
        },
        "modelPaints": {
          "index": "Verniciature Modelli",
          "edit": "Modifica Verniciatura Modello"
        },
        "modelModules": {
          "index": "Moduli Modelli",
          "edit": {
            "index": "Modifica %{name} Dati Base",
            "models": "Modifica %{name} Modelli",
            "prices": "Modifica %{name} Prezzi",
            "hardpoints": "Modifica Hardpoint di %{name}",
            "cargoHolds": "Modifica stive di carico di %{name}",
            "history": "Modifica cronologia del modulo"
          }
        },
        "unlistedModels": {
          "index": "Navi non elencate"
        },
        "modelModulePackages": {
          "index": "Pacchetti Moduli Modelli"
        },
        "commodities": {
          "index": "Commodities",
          "new": "New Commodity",
          "edit": {
            "index": "Edit Commodity"
          }
        },
        "equipment": {
          "index": "Equipment",
          "new": "New Equipment",
          "edit": {
            "index": "Edit Equipment",
            "prices": "Edit Equipment Prices"
          }
        },
        "visualTests": {
          "index": "Test Visivi",
          "notifications": "Notifiche - Test Visivi"
        }
      },
      "notifications": "Notifiche"
    }
  }
}
